module.exports = __webpack_public_path__ + "img/greenScreen.de5e7a60.png";